import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import CheckedCols from '../CheckedCols';

interface Props {
  column: any;
  tableCols: any;
  index: number;
  columnConfig: any;
  onCheckBoxClick: (event: any) => void;
}

const CheckedItem = SortableElement((props: Props) => {
  const { column, tableCols, index, columnConfig, onCheckBoxClick } = props;

  return (
    <CheckedCols
      column={column}
      tableCols={tableCols}
      index={index}
      columnConfig={columnConfig}
      onCheckBoxClick={onCheckBoxClick}
    />
  );
});

export default CheckedItem;
